export const CUSTOM_SVG_ICONS: { name: string; url: string }[] = [
  { name: 'account_cancel_outline', url: '../assets/svg/account_cancel_outline.svg' },
  { name: 'approval_indicator', url: '../assets/svg/approval_indicator.svg' },
  { name: 'archived', url: '../assets/svg/archived.svg' },
  { name: 'bank_outline', url: '../assets/svg/bank_outline.svg' },
  { name: 'barcode', url: '../assets/svg/barcode.svg' },
  { name: 'contract', url: '../assets/svg/contract.svg' },
  { name: 'contract_data', url: '../assets/svg/contract_data.svg' },
  { name: 'database_outline', url: '../assets/svg/database_outline.svg' },
  { name: 'delivered', url: '../assets/svg/delivered.svg' },
  { name: 'division', url: '../assets/svg/suppliertype_division.svg' },
  { name: 'document_edit', url: '../assets/svg/document_edit.svg' },
  { name: 'dotted-square', url: '../assets/svg/dotted-square.svg' },
  { name: 'enrich', url: '../assets/svg/enrich.svg' },
  { name: 'export_failed', url: '../assets/svg/export_failed.svg' },
  { name: 'export_icon', url: '../assets/svg/export_icon.svg' },
  { name: 'export_pending', url: '../assets/svg/export_pending.svg' },
  { name: 'export_successful', url: '../assets/svg/export_successful.svg' },
  { name: 'filter_toggle_close', url: '../assets/svg/filter_toggle_close.svg' },
  { name: 'filter_toggle_open', url: '../assets/svg/filter_toggle_open.svg' },
  { name: 'global_article_star', url: '../assets/svg/global_article_star.svg' },
  { name: 'global_article_toggle', url: '../assets/svg/global_article_toggle.svg' },
  { name: 'global_document', url: '../assets/svg/global_document.svg' },
  { name: 'global_document_edit', url: '../assets/svg/global_document_edit.svg' },
  { name: 'global_document_edit_disabled', url: '../assets/svg/global_document_edit_disabled.svg' },
  { name: 'globalclinicarticle', url: '../assets/svg/globalclinicarticle.svg' },
  { name: 'globalindustryarticle', url: '../assets/svg/globalindustryarticle.svg' },
  { name: 'heart', url: '../assets/svg/heart.svg' },
  { name: 'heart_minus_outline', url: '../assets/svg/heart_minus_outline.svg' },
  { name: 'heart_plus_outline', url: '../assets/svg/heart_plus_outline.svg' },
  { name: 'home_city_outline', url: '../assets/svg/home_city_outline.svg' },
  { name: 'home_pin', url: '../assets/svg/home_pin.svg' },
  { name: 'inactive', url: '../assets/svg/inactive.svg' },
  { name: 'indentation', url: '../assets/svg/indentation.svg' },
  { name: 'lightbulb', url: '../assets/svg/lightbulb.svg' },
  { name: 'main_supplier', url: '../assets/svg/main_supplier.svg' },
  { name: 'newspaper_variant_outline', url: '../assets/svg/newspaper_variant_outline.svg' },
  { name: 'order', url: '../assets/svg/order.svg' },
  { name: 'pharmacy_custom', url: '../assets/svg/pharmacy_custom.svg' },
  { name: 'price_notsigned', url: '../assets/svg/price_notsigned.svg' },
  { name: 'price_signed', url: '../assets/svg/price_signed.svg' },
  { name: 'ref_number', url: '../assets/svg/ref_number.svg' },
  { name: 'transport_clinic', url: '../assets/svg/transport_clinic.svg' },
  { name: 'trash_can_outline', url: '../assets/svg/trash_can_outline.svg' },
  { name: 'truck_alert_outline', url: '../assets/svg/truck_alert_outline.svg' },
  { name: 'truck_full', url: '../assets/svg/truck_full.svg' },
  { name: 'truck_half', url: '../assets/svg/truck_half.svg' },
  { name: 'truck_outline', url: '../assets/svg/truck_outline.svg' },
];
